<script lang="ts">
	import { onMount } from 'svelte'
	// import MenuIcon_ListClients from '$lib/components/Menu/Icons/Items/ListClientsIcon.svelte';
	import {
		Adjustments,
		ArrowCircleRight,
		Beaker,
		Cog,
		CurrencyDollar,
		DocumentAdd,
		DocumentDuplicate,
		DocumentText,
		FastForward,
		Home,
		// Icon,
		Login,
		Logout,
		// Gift,
		ReceiptTax,
		Support,
		Table,
		Tag,
		Ticket,
		UserAdd,
		UserGroup,
		Users	} from 'svelte-hero-icons'

	import { goto } from '$app/navigation'
	import { page } from '$app/stores'
	import MenuSubItem from '$lib/components//Menu/MenuSubItem.svelte'
	import MenuIcon_CreateInvoice from '$lib/components/Menu/Icons/Items/CreateInvoiceIcon.svelte'
	import MenuIcon_Invoices from '$lib/components/Menu/Icons/Items/ListInvoicesIcon.svelte'
	import MenuItem from '$lib/components/Menu/MenuItem.svelte'
	import MenuItemSeparator from '$lib/components/Menu/MenuItemSeparator.svelte'
	import environment from '$lib/environment'
	import { account } from '$lib/stores/account/account'
	import { isAccountOfPlanAdvanced, isSubscriptionNeeded, logout } from '$lib/stores/account/manager'
	import { getEventLogo, hasEventLogo, InitBoSettings, storeBoSettings } from '$lib/stores/bo_settings'
	import { ActiveDialog, dialog } from '$lib/stores/dialog/dialog'
	import { dimensions } from '$lib/stores/dimensions'
	import { menu_manager, menu_store } from '$lib/stores/menu'
	import { openai_visible_store } from '$lib/stores/openai/openai'
    import { AccPlanHasFeatureEnabled, Features_Name } from '$lib/stores/subscription_acc_plan_features/subscription_acc_plan_features'
	import { HELP_URL, PRIVACY_URL, TERMS_URL } from '$lib/urls'


	//let pp = $openai_visible_store

	let currentMenuExpanded: MenuItem
	let workInOnlyOneMenuItemExpandedMode = false

	let featureAIassistant_enabled = false
	// let featureTeamUsers_enabled = false

	export let menuToggled = false

	//--- Update selected menu option
	$: menu_manager.setCurrentOptionFromPageUrl($page.url)

	onMount(async () => {
		await InitBoSettings()
		featureAIassistant_enabled = AccPlanHasFeatureEnabled(Features_Name.AI_Assistant)
		// featureTeamUsers_enabled = AccPlanHasFeatureEnabled(Features_Name.Team_Users)
	})

	let menuCurrentOption = menu_manager.getCurrentOption()

	$: menuCurrentOption = $menu_store.option


	// required receive 'currentOption' for reactive
	const isSelectedOption = (currentOption: string, option: string): boolean => {
		return currentOption === option
	}

	const selectOption = (option: string, route: string) => {
		menu_manager.goOption(option, route)
	}

	function toggleMenu() {
		// console.log('MenuLeft - toggleMenu');
		menuToggled = !menuToggled
	}

	function handleMenuExpanded(e: CustomEvent) {
		// console.log('handleMenuExpanded', e)
		//---
		if (workInOnlyOneMenuItemExpandedMode) {
			if (currentMenuExpanded && currentMenuExpanded != e.detail) {
				currentMenuExpanded.collapse()
			}
			currentMenuExpanded = e.detail
		}
	}

	// Menu options
	function handleDashboard() {
		menu_manager.goDashboard()
	}

	function handleBoSettings() {
		menu_manager.goBoSettings()
	}
	function handleBoSubscription() {
		menu_manager.goBoSubscription()
	}
	function handleBoLogs() {
		menu_manager.goBoLogs()
	}
	function handleBoPdf2Data() {
		menu_manager.goBoPdf2Data()
	}
	function handleBoMonitor() {
		menu_manager.goBoMonitor()
	}
	function handleBoOpenAI() {
		menu_manager.goBoOpenAI()
	}
	// function handleBoIntercom() {
	// 	menu_manager.goBoIntercom()
	// }

	function handleNewInvoice() {
		menu_manager.goNewInvoice()
	}

	function handleInvTemplate() {
		menu_manager.goInvTemplate()
	}

	function handleNewEstimate() {
		menu_manager.goNewEstimate()
	}

	function handleEstTemplate() {
		menu_manager.goEstTemplate()
	}

	function handleNewClient() {
		menu_manager.goNewClient()
	}

	function handleOpenAI() {

		if (!featureAIassistant_enabled) {
			handleSubscribe()
			return
		}
		$openai_visible_store = !$openai_visible_store
	}

	function handleSubscribe() {
		// They want to subscribe
		if (!$account.registered) {
			//goto('/signup?next=/?subscribe');
			goto('/signup')
		} else {
			$dialog = ActiveDialog.Subscribe
		}
	}

	function handleGetPaid() {
		// menu_manager.setCurrentOption("paid")

		// TODO: sometimes stripe is slow, can we do a 'please wait' thing?
		const connectUrl = environment.apiUrl + '/stripe/connect/start'
		if (!$account.registered) {
			goto(`/signup?next=${connectUrl}`)
		} else {
			window.open(connectUrl)
		}
	}
	
	function handleUsers() {
		// if (!featureTeamUsers_enabled) {
		// 	handleSubscribe()
		// 	return
		// }
		selectOption('users', '/users')
	}


	let w = 0
	let h = 0

	$: {
		// console.log("Dimension Menu: " + w + "px, " + h + "px")
		$dimensions.divMenu = { height: h, width: w }
	}

	//$: textMenuPaid = ($account.stripe_connect_id || "") !== "" ? 'Payments' : 'Accept Payments'
	let textMenuPaid = 'Accept Payments'
	$: {
		if (($account.stripe_connect_id || '') !== '' && $account.stripe_connect_charges_enabled)
			textMenuPaid = 'Payments'
		else textMenuPaid = 'Accept Payments'
	}
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<nav
	class="menu-container"
	class:menu-toggled={menuToggled}
	on:click|stopPropagation={toggleMenu}
	bind:clientWidth={w}
	bind:clientHeight={h}
>
	<div class="menu-actual">
		<!--a href="/" on:click|preventDefault={()=>goto('/')} class="flex items-center flex-shrink-0 px-4 h-14"-->
		<a
			href="/"
			on:click|preventDefault={() => selectOption('home', '/')}
			class="flex items-center flex-shrink-0 px-4 h-16 relative"
		>
			<img src="/desktop-logo-new.svg" style="max-width: 144px;" alt="Invoicer.ai" />
			{#key $storeBoSettings}
				{#if hasEventLogo()}
					<img src="/event_logo_{getEventLogo()}.svg" class="event_logo_{getEventLogo()}" alt="Invoicer.ai" />
				{/if}
			{/key}
		</a>
		{#if $storeBoSettings.admin}
			<MenuItemSeparator />

			<!-- iconSource={Cog} -->
			<!-- iconSource={Adjustments}  -->
			<MenuItem
				text="Back Office"
				data-test-id="menu_backoffice"
				iconSource={Cog}
				hasSubItems
				menuExpanded={isSelectedOption(menuCurrentOption, 'bo_settings') ||
					isSelectedOption(menuCurrentOption, 'bo_subscription') ||
					isSelectedOption(menuCurrentOption, 'bo_logs') ||
					isSelectedOption(menuCurrentOption, 'bo_pdf2data') ||
					isSelectedOption(menuCurrentOption, 'bo_monitor') ||
					isSelectedOption(menuCurrentOption, 'bo_openai')}
				on:expanded={handleMenuExpanded}
			>
				<MenuSubItem
					text="Settings"
					data-test-id="menu_backoffice_settings"
					iconSource={Cog}
					isSelected={isSelectedOption(menuCurrentOption, 'bo_settings')}
					on:click={handleBoSettings}
				/>
				<MenuSubItem
					text="Subscription"
					data-test-id="menu_backoffice_subscription"
					iconSource={Cog}
					isSelected={isSelectedOption(menuCurrentOption, 'bo_subscription')}
					on:click={handleBoSubscription}
				/>
				<MenuSubItem
					text="Logs"
					data-test-id="menu_backoffice_logs"
					iconSource={Cog}
					isSelected={isSelectedOption(menuCurrentOption, 'bo_logs')}
					on:click={handleBoLogs}
				/>
				<MenuSubItem
					text="Inv2Data"
					data-test-id="menu_backoffice_inv2data"
					iconSource={Cog}
					isSelected={isSelectedOption(menuCurrentOption, 'bo_pdf2data')}
					on:click={handleBoPdf2Data}
				/>
				<MenuSubItem
					text="Monitor"
					data-test-id="menu_backoffice_monitor"
					iconSource={Cog}
					isSelected={isSelectedOption(menuCurrentOption, 'bo_monitor')}
					on:click={handleBoMonitor}
				/>
				<MenuSubItem
					text="AI settings"
					data-test-id="menu_backoffice_openai"
					iconSource={Cog}
					isSelected={isSelectedOption(menuCurrentOption, 'bo_openai')}
					on:click={handleBoOpenAI}
				/>
				<!-- <MenuSubItem
					text="Intercom"
					data-test-id="menu_backoffice_intercom"
					iconSource={Cog}
					isSelected={isSelectedOption(menuCurrentOption, 'bo_intercom')}
					on:click={handleBoIntercom}
				/> -->
			</MenuItem>
		{/if}

		<MenuItemSeparator />

		<MenuItem
			data-test-id="menu_dashboard"
			text="Dashboard"
			iconSource={Home}
			isSelected={isSelectedOption(menuCurrentOption, 'home')}
			on:click={handleDashboard}
		/>

		<!-- iconSource={DocumentDuplicate}  -->
		<MenuItem
			module="invoices"
			text="Invoices"
			data-test-id="menu_invoices"
			iconComponent={MenuIcon_Invoices}
			hasSubItems
			menuExpanded={isSelectedOption(menuCurrentOption, 'invoice_new') ||
				isSelectedOption(menuCurrentOption, 'invoices') ||
				isSelectedOption(menuCurrentOption, 'invoices_templates')}
			on:expanded={handleMenuExpanded}
		>
			<!-- iconSource={DocumentAdd}  -->
			<MenuSubItem
				permission='$.invoices.view.edit'
				text="New Invoice"
				data-test-id="menu_invoices_new"
				iconComponent={MenuIcon_CreateInvoice}
				isSelected={isSelectedOption(menuCurrentOption, 'invoice_new')}
				on:click={handleNewInvoice}
			/>

			<!-- iconSource={DocumentDuplicate}  -->
			<MenuSubItem
				text="List Invoices"
				data-test-id="menu_invoices_list"
				iconComponent={MenuIcon_Invoices}
				isSelected={isSelectedOption(menuCurrentOption, 'invoices')}
				on:click={() => selectOption('invoices', '/invoices')}
			/>
			<MenuSubItem
				permission='$.invoices.view.edit.template'
				text="PDF Templates"
				data-test-id="menu_invoices_templates"
				iconComponent={MenuIcon_Invoices}
				isSelected={isSelectedOption(menuCurrentOption, 'invoices_templates')}
				on:click={handleInvTemplate}
			/>
		</MenuItem>

		<MenuItem
			module="estimates"
			text="Estimates"
			data-test-id="menu_estimates"
			iconSource={DocumentDuplicate}
			hasSubItems
			menuExpanded={isSelectedOption(menuCurrentOption, 'estimate_new') ||
				isSelectedOption(menuCurrentOption, 'estimates') ||
				isSelectedOption(menuCurrentOption, 'estimates_templates')}
			on:expanded={handleMenuExpanded}
		>
			<MenuSubItem
				permission='$.estimates.view.edit'
				text="New Estimate"
				data-test-id="menu_estimates_new"
				iconSource={DocumentAdd}
				isSelected={isSelectedOption(menuCurrentOption, 'estimate_new')}
				on:click={handleNewEstimate}
			/>

			<MenuSubItem
				text="List Estimates"
				data-test-id="menu_estimates_list"
				iconSource={DocumentDuplicate}
				isSelected={isSelectedOption(menuCurrentOption, 'estimates')}
				on:click={() => selectOption('estimates', '/estimates')}
			/>
			<MenuSubItem
				permission='$.estimates.view.edit.template'
				text="PDF Templates"
				data-test-id="menu_estimates_templates"
				iconComponent={MenuIcon_Invoices}
				isSelected={isSelectedOption(menuCurrentOption, 'estimates_templates')}
				on:click={handleEstTemplate}
			/>
				<!-- on:click={() => selectOption('estimates_templates', '/estimates/templates')} -->
		</MenuItem>

		<!-- iconSource={DocumentDuplicate} -->
		<MenuItem
			module="clients"
			text="Clients"
			data-test-id="menu_clients"
			iconSource={UserGroup}
			hasSubItems
			menuExpanded={isSelectedOption(menuCurrentOption, 'client_new') ||
				isSelectedOption(menuCurrentOption, 'clients')}
			on:expanded={handleMenuExpanded}
		>
			<MenuSubItem
				permission='$.clients.view.edit'
				text="New Client"
				data-test-id="menu_clients_new"
				iconSource={UserAdd}
				isSelected={isSelectedOption(menuCurrentOption, 'client_new')}
				on:click={handleNewClient}
			/>

			<MenuSubItem
				text="List Clients"
				data-test-id="menu_clients_list"
				iconSource={UserGroup}
				isSelected={isSelectedOption(menuCurrentOption, 'clients')}
				on:click={() => selectOption('clients', '/clients')}
			/>
		</MenuItem>

		<MenuItem
			module="items"
			text="Items"
			data-test-id="menu_items"
			iconSource={ArrowCircleRight}
			hasSubItems
			menuExpanded={isSelectedOption(menuCurrentOption, 'items') ||
				isSelectedOption(menuCurrentOption, 'taxes') ||
				isSelectedOption(menuCurrentOption, 'categories')}
			isNew={false}
			on:expanded={handleMenuExpanded}
		>
			<!--MenuSubItem 
				data-test-id="menu_new_item" 
				text="New Item" 
				iconSource={DocumentAdd} 
				isSelected={ isSelectedOption(menuCurrentOption,"item_new") }
				on:click={handleNewItem}  /-->

			<MenuSubItem
				text="List Items"
				data-test-id="menu_items_list"
				iconSource={Tag}
				isSelected={isSelectedOption(menuCurrentOption, 'items')}
				on:click={() => selectOption('items', '/items')}
			/>
			<!--/MenuItem-->

			<!--MenuItem
			text="Taxes"
			iconSource={Tag}
			hasSubItems 
			menuExpanded={ isSelectedOption(menuCurrentOption,"tax_new") || 
						   isSelectedOption(menuCurrentOption,"taxes")  }
			isNew
			on:expanded={handleMenuExpanded}-->

			<!--MenuSubItem 
				data-test-id="menu_new_tax" 
				text="New Tax" 
				iconSource={DocumentAdd} 
				isSelected={ isSelectedOption(menuCurrentOption,"tax_new") }
				on:click={handleNewTax}  /-->

			<MenuSubItem
				text="List Taxes"
				data-test-id="menu_taxes_list"
				iconSource={ReceiptTax}
				isSelected={isSelectedOption(menuCurrentOption, 'taxes')}
				on:click={() => selectOption('taxes', '/taxes')}
			/>
			<!--/MenuItem-->

			<!--MenuItem
			text="Categories"
			iconSource={Tag}
			hasSubItems 
			menuExpanded={ isSelectedOption(menuCurrentOption,"category_new") || 
						isSelectedOption(menuCurrentOption,"categories")  }
			isNew
			on:expanded={handleMenuExpanded}-->

			<!--MenuSubItem 
				data-test-id="menu_new_category" 
				text="New Category" 
				iconSource={DocumentAdd} 
				isSelected={ isSelectedOption(menuCurrentOption,"category_new") }
				on:click={handleNewCategory}  /-->

			<MenuSubItem
				text="List Categories"
				data-test-id="menu_categories_list"
				iconSource={Ticket}
				isSelected={isSelectedOption(menuCurrentOption, 'categories')}
				on:click={() => selectOption('categories', '/categories')}
			/>
		</MenuItem>

		<!-- <MenuItem
			data-test-id="menu_expenses"
			text="Expenses"
			iconSource={Table}
			isSelected={isSelectedOption(menuCurrentOption, 'expenses')}
			isNew newIconPos='inline'
			on:click={() => selectOption('expenses', '/expenses')}
		/> -->
		<MenuItem
			module="expenses"
			text="Expenses"
			data-test-id="menu_expenses"
			iconSource={Table}
			hasSubItems
			menuExpanded={isSelectedOption(menuCurrentOption, 'expenses') ||
					      isSelectedOption(menuCurrentOption, 'expenses_categories')}
			isNew={false}
			on:expanded={handleMenuExpanded}
		>
			<MenuSubItem
				text="List Expenses"
				data-test-id="menu_expenses_list"
				iconSource={Table}
				isSelected={isSelectedOption(menuCurrentOption, 'expenses')}
				on:click={() => selectOption('expenses', '/expenses')}
			/>
			<MenuSubItem
				text="List Categories"
				data-test-id="menu_expenses_categories_list"
				iconSource={Tag}
				isSelected={isSelectedOption(menuCurrentOption, 'expenses_categories')}
				on:click={() => selectOption('expenses_categories', '/expenses_categories')}
			/>
		</MenuItem>

		<MenuItem
			module="ai_assistant"
			data-test-id="menu_invoicerai"
			text="AI Assistant"
			iconSource={Beaker}
			label="Beta"
			isSelected={isSelectedOption(menuCurrentOption, 'openai')}
			on:click={handleOpenAI}
		/>

		<MenuItemSeparator />

		<!-- {#if $account.stripe_subscription_status !== 'active'} -->
		{#if isSubscriptionNeeded() || !isAccountOfPlanAdvanced()}
			<MenuItem
				data-test-id="menu_update_now"
				text="Upgrade Now"
				iconSource={FastForward}
				iconClass="text-emerald-300"
				iconSolid={true}
				isSelected={isSelectedOption(menuCurrentOption, 'upgrade')}
				on:click={handleSubscribe}
			/>
		{/if}

		<MenuItem
			data-test-id="menu_paid"
			text={textMenuPaid}
			iconSource={CurrencyDollar}
			isSelected={isSelectedOption(menuCurrentOption, 'paid')}
			on:click={handleGetPaid}
		/>

		<MenuItemSeparator />
		{#if $account.registered}
			<MenuItem
				data-test-id="menu_logout"
				text="Logout"
				iconSource={Logout}
				isSelected={isSelectedOption(menuCurrentOption, 'logout')}
				on:click={logout}
			/>
		{:else}
			<MenuItem
				data-test-id="menu_login"
				action="/login"
				text="Login"
				iconSource={Login}
				isSelected={isSelectedOption(menuCurrentOption, 'login')}
				on:click={() => goto('/login')}
			/>
		{/if}

		{#if !$account.subscribed}
			<MenuItem
				data-test-id="menu_invoicer_branding"
				text="Turn off Invoicer branding"
				iconSource={Adjustments}
				isSelected={isSelectedOption(menuCurrentOption, 'settings_invoice_branding')}
				on:click={() => selectOption('settings_invoice_branding', '/settings/invoice/branding')}
			/>
			<!-- on:click={() => goto('/settings/invoice/branding')}  /> -->
		{/if}

		<div class="flex flex-col justify-end flex-grow">
			<MenuItemSeparator />

			<MenuItem
				module="settings"
				data-test-id="menu_settings"
				text="Settings"
				iconSource={Cog}
				isSelected={isSelectedOption(menuCurrentOption, 'settings')}
				on:click={() => selectOption('settings', '/settings')}
			/>
			<MenuItem
				module="users"
				data-test-id="menu_users"
				text="Team"
				iconSource={Users}
				isSelected={isSelectedOption(menuCurrentOption, 'users')}
				on:click={handleUsers}
			/>

			<MenuItem data-test-id="menu_support" action={HELP_URL} text="Support" iconSource={Support} />

			<MenuItemSeparator />

			<MenuItem
				data-test-id="menu_privacy"
				target="_blank"
				rel="noopener noreferrer"
				action={PRIVACY_URL}
				text="Privacy"
				iconSource={DocumentText}
			/>

			<MenuItem
				data-test-id="menu_terms"
				target="_blank"
				rel="noopener noreferrer"
				action={TERMS_URL}
				text="Terms"
				iconSource={DocumentText}
			/>
		</div>
	</div>
</nav>

<style lang="postcss">
	.menu-container {
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		width: 80%;
		z-index: 6;
		background: #333;
		/* menu hidden by default */
		transform: translateX(-100%);
		transition:
			ease-in-out transform 0.15s,
			width 0.15s;
		overflow-y: auto;
	}

	.menu-container.menu-toggled {
		/* revealed (moved right) on toggle */
		transform: translateX(0);
	}

	.menu-toggled {
		transform: translateX(0);
	}

	.menu-actual {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	/* 
	.menu-item {
		@apply text-white py-4 flex cursor-pointer;
	}
	.menu-item:hover {
		@apply bg-gray-700;
	}
	.menu-item-selected {
		@apply bg-gray-600 text-emerald-200 font-medium py-4 flex cursor-pointer;
	} 
	*/
	
	.event_logo_christmas {
		position: absolute;
		max-width: 36px;
		left: 6px;
		top: 4px;
	}
	

	@media (min-width: 768px) {
		.menu-container {
			width: 12rem;
			transform: translateX(0);
		}
		.menu-actual {
			height: 100%;
		}
	}
	@media (min-width: 1024px) {
		.menu-container {
			width: 14rem;
		}
	}
</style>
